const state = {
    loggedIn: false
};
export default state;
